<template>
	<div class="px-3 xl:px-0">
		<div class="flex justify-between items-center px-1 text-white xl:pl-12 xl:pr-4">
			<span class="text-2xl font-medium">Relacja {{ galaName }}</span>
		</div>
		<div class="bg-zt-normal flex flex-col rounded-zt"
				 :class="{ 'pr-1 xl:pl-[44px] xl:pr-12': !additional }">
			<div class="my-4 flex flex-col items-stretch space-y-2">
				<transition-group name="fade"
                          v-if="commentariesToShow.length > 0
                                  && ((commentaryData.status === 'NS' && additional) || !additional)">
					<div v-for="comm in commentariesToShow" :key="comm.id"
							 class="commentary relative
                      last:before:h-[calc(100%_-_8px)] last:before:!translate-y-0
                      xl:last:before:!h-[calc(100%_-_14px)]">
						<div class="commentary-content text-base font-light leading-[21px] rounded-zt
                        p-2.5 max-w-full break-words w-full xl:max-w-full xl:w-auto"
								 :class="{ 'shadow-[#314056] shadow-[0_4px_10px] !bg-[#314056]': commentaryData.newMessagesIds.includes(comm.id) }">
              <div>
                <div v-if="comm.fight_start" class="mb-1 w-full text-[#93A3BA] text-sm">
                  <span class="font-semibold w-full">ZACZYNAMY WALKĘ</span>
                </div>
                <div class="mx-auto" v-html="comm.content"></div>
              </div>
              <div class="absolute left-0 content-[''] w-[2px] h-[30px] rounded-full top-1/2 -translate-y-1/2 border-2
                        border-zt-red rounded-tr-md rounded-br-md rounded-tl-none rounded-bl-none"></div>
						</div>
					</div>
				</transition-group>
			</div>
			<button v-if="(commentaryMsgsCount < videos.length)"
							@click="commentaryMsgsCount += 10"
							class="w-fit block mx-auto mt-3 mb-2 zt-hover underline text-sm text-zt-more">
				ROZWIŃ RELACJĘ
			</button>
		</div>
	</div>
</template>

<script>
import utils_mixin from "../../mixins/utils_mixin";
import {Notice} from "../../../assets/js/Notice";

export default {
	name: 'Video',
	inject: ['WP'],
	mixins: [utils_mixin],
	data() {
		return {
			commentaryMsgsCount: 10,
			videos: [],
			fullCommentary: true,
		}
	},
	props: ['galaId', 'galaName', 'commentaryData', 'additional'],
	updated() {
		observeEmbedded();
	},
	computed: {
		commentariesToShow() {
			if (this.commentaryData.status === 'EN') {
				return this.videos
					.slice()
					.reverse()
					.slice(0, this.commentaryMsgsCount);
			} else {
				return this.videos
					.slice(0, this.commentaryMsgsCount);
			}
		},
		followsNumberWidth() {
			if (this.commentaryData.currentlyFollows * 3 >= 100) {
				return '28px';
			} else if (this.commentaryData.currentlyFollows * 3 >= 10) {
				return '20px';
			} else {
				return '10px';
			}
		},
	},
	mounted() {
		this.videos = this.commentaryData.commentaryMsgs.filter(v => v.is_video === '1');
	},
	methods: {
		getTime(date) {
			let dateTime = this.DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss');
			if (this.commentaryData.status === 'IP') {
				let nowDateTime = this.DateTime.now();
				let diff = nowDateTime.diff(dateTime, ['hours', 'minutes', 'seconds', 'milliseconds']);

        if (diff.minutes === 0) {
          return `Przed \n chwilą`;
        }
        else {
          return dateTime.toFormat('HH:mm');
        }
			} else if (this.additional) {
				return dateTime.toFormat('dd.MM.yyyy');
			} else {
				return dateTime.toFormat('HH:mm');
			}
		},
		copyLinkToCommentary() {
			navigator.clipboard.writeText(window.location.href);
			this.addInternalNotification(new Notice()
				.setContent('Skopiowano link do relacji'));
		},
		toggleSound() {
			this.commentaryData.soundEnabled = !this.commentaryData.soundEnabled;

			this.addInternalNotification(new Notice()
				.setContent((this.commentaryData.soundEnabled ? 'Włączono' : 'Wyłączono') + ' dźwięk powiadomienia'));

			localStorage.setItem('commentary_sounds', this.commentaryData.soundEnabled);
		},
	}
}
</script>

<style scoped>
.commentary a {
	@apply text-sm !important;
}

.tab-selected {
	@apply text-zt-red relative;
}

.commentary-content:deep(p) {
	@apply text-left !important;
}
.commentary-content:deep(blockquote) {
	@apply px-4 py-2.5 mb-0 !important;
}
.commentary-content:deep(div.twitter-tweet) {
  @apply m-0 !important;
}
.commentary-content:deep(iframe.instagram-media) {
  @apply m-0 !important;
}
</style>